import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { decodeToken } from 'react-jwt';
import cLoadingImage from '../../assets/img/preloader-black.gif';
import Header from './Header';
import SideMenu from './SideMenu';
import Axios from '../../config/Axios';
import '../../assets/scss/variables.scss';
import './styles/font.scss';
import './styles/page.scss';
import { oLocalStorage } from '../../config/EncodedLocalStorage';
import { signIn } from '../../config/Authentication';
import RcmpHeader from "../../components_v2/molecules/Header"
import InfoCircleIcon from "../../assets_v2/icons/InfoCircleIcon"
class Page extends Component {
  constructor(oProps) {
    super(oProps);
    this.state = {
      nUserId: oLocalStorage.get('nUserId'),
      oUser: {
        user_cname: '',
        user_cavatar: null,
        customer: {
          cust_nquotaused: null,
          nDiskSpace: null
        }
      },
      bLoading: true,
      bIsMenuOpened: false,
      bIsTransitionEnd: false,
      bSyncLoading: true
    };
    this.bIsSetFooter = true;
  }

  componentDidMount() {
    this.fetchUser()
      .then(cToken => {
        if (!cToken) {
          window.location.href = '/';
        }
        const { oUser, cStorageToken } = decodeToken(cToken) ?? {};
        signIn(cStorageToken, true);

        this.setState({
          bSyncLoading: false,
          oUser,
          bLoading: false
        });
      })
      .catch(oError => {
        console.error('Error fetching user:', oError);
      });
  }

  changeIsMenuOpened = () => {
    const { bIsMenuOpened } = this.state;
    if (bIsMenuOpened) {
      this.setState({ bIsMenuOpened: false, bIsTransitionEnd: false });
    } else {
      this.setState({ bIsMenuOpened: true });
    }
  };

  fetchUser = () => {
    const { nUserId } = this.state;
    return Axios.get(`/user-authenticate/${nUserId}`).then(oResponse => oResponse.data);
  };

  render() {
    // Extrai as propriedades do roteamento fornecidas pelo nosso withRouter
    const {
      cId,
      className,
      bCentered,
      children,
      rcmpBreadcrumb,
      cTitle,
      cImage,
      cDescription,
      rcmpCardHeader,
      cCurrentSideMenuOption,
      bIsUserConfigMenu,
      loading
    } = this.props;
    let cClassName = className || '';

    if (this.state.bSyncLoading) {
      return <></>;
    }

    if (bCentered === 'true') {
      cClassName += ' centered';
    }

    if (this.state.bIsMenuOpened) {
      cClassName += ' menu-expanded';
    }

    if (this.state.bIsTransitionEnd) {
      cClassName += ' sidemenu-names';
    }

    return (
      <div
        className={`v2-page ${cClassName}`}
        onTransitionEnd={() => {
          this.setState({
            bIsTransitionEnd: this.state.bIsMenuOpened
          });
        }}
      >
        {/*
        <SideMenu
          cCurrentSideMenuOption={cCurrentSideMenuOption}
          bIsUserConfigMenu={bIsUserConfigMenu}
          oUser={this.state.oUser}
          bIsOpened={this.state.bIsMenuOpened}
          fnMenuOpenEvent={this.changeIsMenuOpened}
        />
        */}
        {this.state.bLoading || loading === 1 ? (
          <div className="centered-loading">
            <img alt={intl.get('loading')} src={cLoadingImage} />
          </div>
        ) : (
          <div className="v2-page-container">
            {/*
            <Header
              cCurrentHeaderOption={cCurrentSideMenuOption}
              rcmpBreadcrumb={rcmpBreadcrumb}
              cTitle={cTitle}
              cImage={cImage}
              cDescription={cDescription}
              oUser={oUser}
            />
            */}
            <RcmpHeader
              cTitlePage={cTitle}
              elIcon={cImage ? <img src={cImage} alt={cTitle} /> : null}
              aBreadCrumbs={rcmpBreadcrumb}
            />

            <div className="v2-page-content">
              <div id={cId} className="card v2-page-card">
                {rcmpCardHeader}
                <div id={cId} className="card-body">
                  {children}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Page.defaultProps = {
  className: '',
  cId: '',
  bCentered: false,
  children: [],
  rcmpBreadcrumb: '',
  cTitle: '',
  cDescription: '',
  rcmpCardHeader: '',
  cCurrentSideMenuOption: '',
  bIsUserConfigMenu: false,
  loading: 1
};

export default Page;
